module.exports = __webpack_public_path__ + "img/a0106d4.jpg";